export const YES_TOOLS_CLASS_OPTIONS = [
  { value: "5", label: "5. Sınıf" },
  { value: "6", label: "6. Sınıf" },
  { value: "7", label: "7. Sınıf" },
  { value: "8", label: "8. Sınıf" },
  { value: "9", label: "9. Sınıf" },
  { value: "10", label: "10. Sınıf" },
  { value: "11", label: "11. Sınıf" },
  { value: "12", label: "12. Sınıf" },
  { value: "Mezun", label: "Mezun" },
] as const;

export const YES_TOOLS_GRADUATE_TRACK_OPTIONS = [
  { value: "sayisal", label: "Sayısal" },
  { value: "sozel", label: "Sözel" },
  { value: "esit_agirlik", label: "Eşit Ağırlık" },
] as const;

export const YES_TOOLS_PANEL_HOSTNAME = "panel.yes.tools";
const YES_TOOLS_PANEL_HOSTNAMES = new Set(["panel.yes.tools", "test.app.cozizle.com"]);
const YES_TOOLS_DEV_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

export const isYesToolsHostname = (hostname?: string | null) => {
  const normalized = String(hostname || "")
    .trim()
    .toLocaleLowerCase("tr-TR")
    .replace(/^https?:\/\//i, "")
    .split("/")[0]
    .split(",")[0]
    .split(":")[0];

  if (YES_TOOLS_PANEL_HOSTNAMES.has(normalized)) {
    return true;
  }

  return process.env.NODE_ENV !== "production" && YES_TOOLS_DEV_HOSTNAMES.has(normalized);
};

export const normalizeYesToolsClassValue = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) return null;

  const comparable = raw
    .toLocaleLowerCase("tr-TR")
    .replace(/[^0-9a-zçğıöşü]/gu, "");

  if (comparable === "mezun") {
    return "Mezun";
  }

  const numericMatch = comparable.match(/^(5|6|7|8|9|10|11|12)(sinif|sınıf)?$/u);
  if (numericMatch) {
    return numericMatch[1];
  }

  return null;
};

export const formatYesToolsClassLabel = (value?: string | null) => {
  const normalizedValue = normalizeYesToolsClassValue(value);
  if (!normalizedValue) return "";

  return normalizedValue === "Mezun" ? "Mezun" : `${normalizedValue}. Sınıf`;
};

export const normalizeYesToolsGraduateTrackValue = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) return null;

  const comparable = raw
    .toLocaleLowerCase("tr-TR")
    .replace(/[^0-9a-zçğıöşü]/gu, "");

  if (comparable === "sayisal") {
    return "sayisal";
  }

  if (comparable === "sozel") {
    return "sozel";
  }

  if (comparable === "esitagirlik" || comparable === "eşitağırlık" || comparable === "ea") {
    return "esit_agirlik";
  }

  return null;
};

export const formatYesToolsGraduateTrackLabel = (value?: string | null) => {
  const normalizedValue = normalizeYesToolsGraduateTrackValue(value);
  if (!normalizedValue) return "";

  return (
    YES_TOOLS_GRADUATE_TRACK_OPTIONS.find((option) => option.value === normalizedValue)?.label || ""
  );
};

export const isYesToolsGraduateTrackRequired = (classValue?: string | null) => {
  const normalizedValue = normalizeYesToolsClassValue(classValue);

  return normalizedValue === "11" || normalizedValue === "12" || normalizedValue === "Mezun";
};

export const getAllowedYesToolsClassOptions = (_birthDate?: string | Date | null) => {
  return YES_TOOLS_CLASS_OPTIONS;
};

export const getYesToolsClassSelectionError = (
  _birthDate?: string | Date | null,
  selectedClassLevel?: string | null,
  selectedGraduateTrack?: string | null
) => {
  const normalizedValue = normalizeYesToolsClassValue(selectedClassLevel);
  if (!normalizedValue) {
    return selectedClassLevel ? "Geçerli bir sınıf seçiniz." : "";
  }

  if (
    isYesToolsGraduateTrackRequired(normalizedValue) &&
    !normalizeYesToolsGraduateTrackValue(selectedGraduateTrack)
  ) {
    return "Mezun için alan seçimi zorunludur.";
  }

  return "";
};
